import { useState } from 'react'
import { cfIconSvgProps } from '@utils/iconSvg.js'

export type AlertVariant = 'success' | 'warning' | 'danger' | 'info'

function AlertIcon({ variant }: { variant: AlertVariant }) {
  const common = cfIconSvgProps(20)

  switch (variant) {
    case 'success':
      return (
        <svg {...common}>
          <path d='M20 6L9 17l-5-5' />
        </svg>
      )
    case 'warning':
      return (
        <svg {...common}>
          <path d='M12 9v4M12 17h.01' strokeLinecap='round' />
          <path d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' />
        </svg>
      )
    case 'danger':
      return (
        <svg {...common}>
          <circle cx='12' cy='12' r='10' />
          <path d='M12 8v4M12 16h.01' strokeLinecap='round' />
        </svg>
      )
    default:
      return (
        <svg {...common}>
          <circle cx='12' cy='12' r='10' />
          <path d='M12 16v-4M12 8h.01' strokeLinecap='round' />
        </svg>
      )
  }
}

interface Props {
  variant?: AlertVariant
  message: string
  title?: string
  dismissible?: boolean
  onDismiss?: () => void
}

export function Alert({ variant = 'info', message, title, dismissible = false, onDismiss }: Props) {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  const handleDismiss = () => {
    setDismissed(true)
    onDismiss?.()
  }

  return (
    <div className={`cf-alert cf-alert--${variant}`} role='alert'>
      <span className='cf-alert__icon' aria-hidden>
        <AlertIcon variant={variant} />
      </span>
      <div className='cf-alert__body'>
        {title && <strong className='cf-alert__title'>{title}</strong>}
        <p className='cf-alert__message'>{message}</p>
      </div>
      {dismissible && (
        <button
          className='cf-alert__dismiss'
          type='button'
          aria-label='Fechar alerta'
          onClick={handleDismiss}
        >
          ×
        </button>
      )}
    </div>
  )
}
